/**
 * @file 年作成
 */
'use strict';

/**
 * @classname CreateYear
 * @classdesc 年作成
 */
export default class CreateYear {
	/**
	 * @constructor
	 * @param {jQuery} $e - .create-year
	 */
	constructor($e) {
		console.log('CreateYear.constructor');
		const date = new Date();
		const year = String(date.getFullYear());
		console.log(year);
		let startYear = year.slice(2,4);
		console.log(startYear);
		const endYear = Number(startYear) + 15;
		console.log(endYear)
		let options = '<option value="">年</option>';
		for(let i = startYear; i <= endYear; i++){
			options += `<option value="${i}">${i}</option>`;
		}
		$e.html(options);
	};
}
